import { AxiosResponse } from 'axios';

import API from '../Api';
import { getUserToken, logUserOut } from '../utils/login';
// Types.
import { ContactMethod } from '../types/contract';

export const getContactMethod = async (dataOwnerCustomerId: number, actingCustomerId: number, contractNo: number): Promise<ContactMethod> => {
  const { bearer } = getUserToken();

  if (!bearer || bearer.length === 0) {
    logUserOut();
  }

  const contactMethodRequest: AxiosResponse<ContactMethod> = await API({
    method: 'get',
    url: `/v1/getContactMethod/${dataOwnerCustomerId}/${actingCustomerId}/${contractNo}`,
    headers: {
      Authorization: `Bearer ${bearer}`,
    },
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        logUserOut();
      }
      return error.response;
    }
  });
  return contactMethodRequest.data;
};
